"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputField = exports.BaseInputText = exports.InputRadio = exports.Select = exports.InputCheckbox = exports.InputCheckboxIndeterminate = exports.InputReset = exports.InputSubmit = exports.TextArea = exports.InputRange = exports.InputNumber = exports.InputPassword = exports.InputEmail = exports.InputColor = exports.InputText = void 0;
var s_js_1 = require("s-js");
var Surplus = require("surplus");
var surplus_mixin_data_1 = require("surplus-mixin-data");
var internal_components_1 = require("./internal-components");
function InputText(props) {
    return (<BaseInputText type="text" {...props}>
            {props.children}
        </BaseInputText>);
}
exports.InputText = InputText;
function InputColor(props) {
    return (<BaseInputText type="color" {...props}>
            {props.children}
        </BaseInputText>);
}
exports.InputColor = InputColor;
function InputEmail(props) {
    return (<BaseInputText type="email" {...props}>
            {props.children}
        </BaseInputText>);
}
exports.InputEmail = InputEmail;
function InputPassword(props) {
    return (<BaseInputText type="password" {...props}>
            {props.children}
        </BaseInputText>);
}
exports.InputPassword = InputPassword;
function InputNumber(props) {
    return (<BaseInputText type="number" {...props}>
            {props.children}
        </BaseInputText>);
}
exports.InputNumber = InputNumber;
function InputRange(props) {
    return (<BaseInputText type="range" {...props} debounce={0}>
            {props.children}
        </BaseInputText>);
}
exports.InputRange = InputRange;
function TextArea(props) {
    var htmlProps = internal_components_1.filterNonHTMLProps(props);
    var errorClasses = props.classes || internal_components_1.defaultCSSClasses;
    return internal_components_1.__BaseInputComponent(props, convertFromInputState, convertToInputState, render);
    function convertFromInputState(inputState, currentSignal) {
        if (props.trimWhitespace && currentSignal) {
            // To avoid whitespace in input from being removed, compare against trimmed current.
            if (inputState.value === currentSignal.trim())
                return currentSignal;
            return inputState.value;
        }
        else {
            return inputState.value;
        }
    }
    function convertToInputState(signalValue) {
        return props.trimWhitespace ? signalValue.trim() : signalValue;
    }
    function render(signal, handleOnBlur) {
        return (<textarea {...htmlProps} class={internal_components_1.joinClasses(props, errorClasses)} id={props.data().name} name={props.data().name} disabled={isDisabled(props)} onBlur={handleOnBlur} fn={surplus_mixin_data_1.default(signal)}/>);
    }
}
exports.TextArea = TextArea;
function InputSubmit(props) {
    return <input {...props} type="submit"/>;
}
exports.InputSubmit = InputSubmit;
function InputReset(props) {
    return <input {...props} type="reset"/>;
}
exports.InputReset = InputReset;
/** Checkbox that can be used for cases like a select all where an indeterminate state should be shown  */
function InputCheckboxIndeterminate(props) {
    var _a;
    var refInput = undefined;
    var checkboxSignals = props.checkboxSignals, selectAll = props.selectAll;
    var selectAllName = (_a = props.selectAllName) !== null && _a !== void 0 ? _a : "select-all";
    var optProps = props;
    delete optProps.checkboxSignals;
    delete optProps.selectAllName;
    delete optProps.selectAll;
    window.requestAnimationFrame(init);
    var hasError = s_js_1.default(function () { return checkboxSignals().value.every(function (it) { return it().error === 0; }); });
    return (<input ref={refInput} id={selectAllName} aria-invalid={hasError() ? "true" : "false"} aria-errormessage={hasError() ? selectAllName + "-err" : undefined} disabled={checkboxSignals().value.every(function (it) { return it().isDisabled; })()} onBlur={onBlur} type="checkbox" fn={surplus_mixin_data_1.default(selectAll)}/>);
    function onBlur() {
        s_js_1.default.freeze(function () {
            s_js_1.default.sample(s_js_1.default.sample(checkboxSignals).value).forEach(function (it) {
                var curr = s_js_1.default.sample(it);
                it(__assign(__assign({}, curr), { isTouched: true }));
            });
        });
    }
    function init() {
        s_js_1.default.on(checkboxSignals, function () {
            checkboxSignals().value.forEach(function (sig) {
                s_js_1.default.on(sig, function () {
                    var sampCheckboxSignals = s_js_1.default.sample(checkboxSignals);
                    var totalChecked = sampCheckboxSignals.value.reduce(function (total, it) { return total + (s_js_1.default.sample(it).value ? 1 : 0); }, 0)();
                    // Work with raw html to avoid changing selectAll signals. Otherwise we'd have runaway computations
                    // when we update the selectAll signal -> updates currSignals -> updates selectAll -> etc -> etc -> etc
                    refInput.indeterminate = false;
                    if (totalChecked === 0) {
                        refInput.checked = false;
                    }
                    else if (totalChecked === s_js_1.default.sample(sampCheckboxSignals.value).length) {
                        refInput.checked = true;
                    }
                    // indeterminate
                    else if (totalChecked > 0 &&
                        totalChecked < s_js_1.default.sample(sampCheckboxSignals.value).length) {
                        // Ensures that checking an indeterminate checkbox will set checked to true. Else, it will flip true/false
                        // depending on previous state. Which causes inconsistent behaviour
                        refInput.checked = false;
                        refInput.indeterminate = true;
                    }
                });
            });
        });
        s_js_1.default.on(selectAll, function () {
            selectAllRows();
        }, undefined, true);
    }
    function selectAllRows() {
        var isSelected = selectAll();
        s_js_1.default.freeze(function () {
            s_js_1.default.sample(s_js_1.default.sample(checkboxSignals).value).forEach(function (it) {
                var curr = s_js_1.default.sample(it);
                if (isSelected !== curr.value) {
                    it(__assign(__assign({}, curr), { __v: curr.__v + 1, value: isSelected }));
                }
            });
        });
    }
}
exports.InputCheckboxIndeterminate = InputCheckboxIndeterminate;
function InputCheckbox(props) {
    return (<BaseInputText {...props} debounce={0} type="checkbox">
            {props.children}
        </BaseInputText>);
}
exports.InputCheckbox = InputCheckbox;
function hasError(sig) {
    return !!(sig.isTouched && sig.error);
}
function Select(props) {
    var htmlProps = internal_components_1.filterNonHTMLProps(props);
    return internal_components_1.__BaseInputComponent(__assign(__assign({}, props), { debounce: 0 }), convertFromInputState, convertToInputState, render);
    function convertFromInputState(inputState, currentSignal) {
        return indexOf(inputState.value);
    }
    function convertToInputState(selected) {
        // Selected is one of the numbers set in the value attribute of an option.
        // If no option is currently selected, then selected == 0. Since -1 isn't a valid
        // index
        if (selected === 0)
            return undefined;
        return props.options[selected - 1];
    }
    function indexOf(value) {
        if (value == null)
            return 0;
        var index = props.options.indexOf(value);
        if (index === -1) {
            console.warn("Can't find option", JSON.stringify(value), JSON.stringify(props.options));
        }
        return index + 1; // Add 1 because 0 is a reserved value setting none as selected
    }
    function label(i) {
        var option = props.options[i];
        if (props.selector) {
            // selector is the name of a field in an object in the props.options array
            if (typeof props.selector === "string") {
                return option[props.selector];
            }
            // selector is a function that generates a label
            else {
                return props.selector(option);
            }
        }
        else {
            // In this case props.options is assumed to be an array of strings. The label is just the element
            return option;
        }
    }
    function render(signal, handleOnBlur) {
        var errorClasses = props.classes || internal_components_1.defaultCSSClasses;
        return (<select {...htmlProps} id={props.data().name} aria-invalid={hasError(props.data()) ? "true" : "false"} aria-errormessage={hasError(props.data()) ? props.data().name + "-err" : undefined} fn={surplus_mixin_data_1.default(signal)} class={internal_components_1.joinClasses(props, errorClasses)} disabled={isDisabled(props)} onBlur={function () {
                var _a;
                handleOnBlur();
                (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props);
            }}>
                {props.options.map(function (it, i) {
                var text = label(i);
                var value = i + 1; // Add 1 because 0 is a reserved value setting none as selected
                return <option value={value}>{text}</option>;
            })}
            </select>);
    }
}
exports.Select = Select;
function isDisabled(props) {
    return (props.data().isDisabled ||
        (typeof props.disabled === "function" ? props.disabled() : !!props.disabled));
}
function InputRadio(props) {
    var htmlProps = internal_components_1.filterNonHTMLProps(props);
    var errorClasses = props.classes || internal_components_1.defaultCSSClasses;
    return internal_components_1.__BaseInputComponent(__assign(__assign({}, props), { debounce: 0 }), convertFromInputState, convertToInputState, render);
    function convertFromInputState(inputState, _currentSignal) {
        return indexOf(inputState.value);
    }
    function convertToInputState(selected) {
        return selected === 0 ? undefined : props.options[selected - 1];
    }
    function render(signal, handleOnBlur) {
        var initialInput = s_js_1.default.sample(props.data);
        var labelClass = props.radioClass === undefined ? "" : props.radioClass;
        var radioSignals = props.options.map(function (it) { return s_js_1.default.value(indexOf(initialInput.value)); });
        s_js_1.default.on(props.data, function () {
            var index = s_js_1.default.sample(signal);
            s_js_1.default.freeze(function () {
                radioSignals.forEach(function (it, i) {
                    it(index);
                });
            });
        });
        radioSignals.forEach(function (it, i) {
            s_js_1.default.on(it, function () {
                var orig = it();
                var curr = s_js_1.default.sample(signal);
                if (curr !== orig) {
                    signal(orig);
                }
            });
        });
        return (<fieldset {...htmlProps} class={internal_components_1.joinClasses(props, errorClasses)}>
                <legend>{props.legendText}</legend>
                {props.options.map(function (option, i) {
                return (<label class={labelClass} for={props.data().name + "_" + i}>
                            <input class={internal_components_1.joinClasses(props, errorClasses)} aria-invalid={hasError(props.data()) ? "true" : "false"} aria-errormessage={hasError(props.data()) ? props.data().name + "-err" : undefined} disabled={isDisabled(props)} fn={surplus_mixin_data_1.default(radioSignals[i], i + 1)} id={props.data().name + "_" + i} name={props.data().name} onBlur={function () {
                        var _a;
                        handleOnBlur();
                        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props);
                    }} type="radio" value={i + 1}/>
                            <span>{label(i)}</span>
                        </label>);
            })}
            </fieldset>);
    }
    function indexOf(value) {
        return props.options.indexOf(value) + 1;
    }
    function label(i) {
        var option = props.options[i];
        if (props.selector) {
            if (typeof props.selector === "string") {
                // check if selector is the name of a field in option
                return option[props.selector];
            }
            else {
                // else it's a user provided function to create a string.
                return props.selector(option);
            }
        }
        else {
            return option;
        }
    }
}
exports.InputRadio = InputRadio;
function BaseInputText(props) {
    // special case. To support formatting input[number] with string make sure to convert the startValue to a number
    var htmlProps = internal_components_1.filterNonHTMLProps(props);
    var errorClasses = props.classes || internal_components_1.defaultCSSClasses;
    var compareFn = props.type === "number"
        ? function (a, b) { return Number(a) !== Number(b); }
        : undefined;
    var currSelection = -1, inputDom;
    return internal_components_1.__BaseInputComponent(props, convertFromInputState, convertToInputState, render, compareFn);
    function convertFromInputState(inputState, currentSignal) {
        if (props.trimWhitespace && currentSignal) {
            // To avoid whitespace in input from being removed, compare against trimmed current.
            if (inputState.value === currentSignal.trim())
                return currentSignal;
            return inputState.value;
        }
        else if (props.type === "number") {
            // Normally would expect inputState to be a number. In case we want to force the format of a number,
            // we support sending a string input value
            if (typeof inputState.value === "string") {
                if (inputState.value === currentSignal)
                    return currentSignal;
                return inputState.value;
            }
            else {
                if (inputState.value === (currentSignal === "" ? undefined : Number(currentSignal))) {
                    return currentSignal;
                }
                return inputState.value;
            }
        }
        else if (props.type === "range") {
            if (inputState.value === Number(currentSignal))
                return currentSignal;
            return inputState.value;
        }
        else {
            return inputState.value;
        }
    }
    function convertToInputState(signalValue) {
        // To support fixed prop on numbers, we need to move cursor after truncating input
        if (props.type === "number") {
            inputDom === null || inputDom === void 0 ? void 0 : inputDom.setSelectionRange(currSelection, currSelection);
        }
        // To keep the types nice. Convert text to a number when using certain input types
        if (props.type === "number" || props.type === "range") {
            if (signalValue === "") {
                // Handle case where the input is deleted
                return undefined;
            }
            else {
                return Number(signalValue);
            }
        }
        return props.trimWhitespace ? signalValue.trim() : signalValue;
    }
    function render(signal, handleOnBlur) {
        /** Currently only using for number inputs, but could expand for others. Number inputs can have restrictions. For example, max decimals.
         * Create a wrapper signal so that we can update the input with the removed digits before sending the input up
         * */
        var sigInner = s_js_1.default.data(props.type === "number"
            ? formatForNumber(s_js_1.default.sample(signal), props)
            : s_js_1.default.sample(signal));
        /** Help track when we recursively call sigInner */
        var looping = false;
        s_js_1.default.on(signal, function () {
            if (s_js_1.default.sample(sigInner) !== signal()) {
                if (props.type === "number") {
                    sigInner(formatForNumber(signal(), props));
                }
                else {
                    sigInner(signal());
                }
            }
        }, undefined, true);
        s_js_1.default.on(sigInner, function () {
            var _a;
            // save current cursor position
            if (props.type === "number") {
                var truncated = formatForNumber(sigInner(), props);
                if (!looping)
                    currSelection = (_a = inputDom.selectionStart) !== null && _a !== void 0 ? _a : -1;
                if (truncated !== sigInner()) {
                    looping = true;
                    sigInner(truncated);
                    return;
                }
                if (s_js_1.default.sample(signal) === sigInner()) {
                    currSelection -= 1;
                }
            }
            looping = false;
            signal(sigInner());
        }, undefined, true);
        inputDom = (<input {...htmlProps} {...{ autocomplete: "off" }} aria-invalid={hasError(props.data()) ? "true" : "false"} aria-errormessage={hasError(props.data()) ? props.data().name + "-err" : undefined} class={internal_components_1.joinClasses(props, errorClasses)} id={props.data().name} inputMode={getInputMode(props)} pattern={getPatten(props)} name={props.data().name} disabled={isDisabled(props)} onBlur={function () {
                var _a;
                handleOnBlur();
                (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props);
            }} fn={surplus_mixin_data_1.default(sigInner)}>
                {props.children}
            </input>);
        var containerClass = "inputContainer " +
            (props.prefixComponent ? "prefix " : "") +
            (props.postfixComponent ? "postfix " : "");
        return props.prefixComponent || props.postfixComponent ? (<div class={containerClass}>
                {inputDom}
                {props.prefixComponent && (<div class="inputInline prefix">{props.prefixComponent}</div>)}
                {props.postfixComponent && (<div class="inputInline postfix">{props.postfixComponent}</div>)}
            </div>) : (inputDom);
    }
}
exports.BaseInputText = BaseInputText;
function getInputMode(props) {
    return props.type === "number" ? "decimal" : "";
}
function getPatten(props) {
    return props.type === "number" ? "[.0-9]*" : "";
}
function formatForNumber(value, config) {
    if (typeof value === "number")
        value = "" + value;
    var sanitized = value.replace(/[^\d.-]/g, "");
    if (!config.fixed)
        return sanitized;
    var iDecimal = sanitized.indexOf(".");
    var numeric = sanitized.substring(0, iDecimal !== -1 ? iDecimal : config.fixed.max) || "", decimal = (sanitized.substring(iDecimal !== -1 ? iDecimal + 1 : sanitized.length) || "").replace(".", ""); // remove any extra periods
    var newDecimal = decimal.substring(0, config.fixed.decimal), remainingDigits = config.fixed.max - newDecimal.length;
    return "" + numeric.substring(0, remainingDigits) + (iDecimal != -1 ? "." + newDecimal : "");
}
function compareShallow(a, b) {
    if (typeof a !== "object" || typeof b !== "object")
        return true;
    if (Object.keys(a).length !== Object.keys(b).length)
        return true;
    for (var _i = 0, _a = Object.keys(a); _i < _a.length; _i++) {
        var key = _a[_i];
        // Using for-in in a object you can iterate the properties
        var a_value = a[key];
        var b_value = b[key];
        if (a_value !== b_value) {
            return true;
        }
    }
    return false;
}
function InputField(props) {
    var _a;
    return internal_components_1.__BaseInputComponent(props, convertFromInputState, convertToInputState, render, (_a = props === null || props === void 0 ? void 0 : props.objectComparator) !== null && _a !== void 0 ? _a : compareShallow);
    function convertFromInputState(inputState) {
        return inputState.value;
    }
    function convertToInputState(value) {
        return value;
    }
    function render(signal, handleOnBlur) {
        // TODO: Can't set other properties like disabled because it causes infinite rerenders. It only owrked before because we used primitive inputs
        // return <Component
        //     // {...htmlProps}
        //     // class={joinClasses(props, errorClasses)}
        //     // disabled={props.data().isDisabled || props.disabled}
        //     data={signal}/>;
        return props.children(signal, handleOnBlur);
    }
}
exports.InputField = InputField;
//# sourceMappingURL=components.jsx.map